import React, { useState } from 'react';
import './SeguimientoPedidos.css'; // Acordate de crear este CSS

const SeguimientoPedidos = () => {
  const [dniBusqueda, setDniBusqueda] = useState('');
  const [pedidos, setPedidos] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);

  const buscarPedidos = async (e) => {
    e.preventDefault();
    if (!dniBusqueda.trim()) return;

    setCargando(true);
    try {
      const respuesta = await fetch(`https://api.pascolo.com.ar/api/web/pedidos/${dniBusqueda}`);
      const data = await respuesta.json();
      
      setPedidos(data);
      setBusquedaRealizada(true);
    } catch (error) {
      console.error("Error consultando DNI:", error);
      alert("Hubo un error de conexión.");
    } finally {
      setCargando(false);
    }
  };

  const formatearPrecio = (precio) => {
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(precio);
  };

  const traducirEstado = (estado) => {
    const estados = {
      'borrador': 'Pendiente de Pago',
      'pendiente': 'En Preparación',
      'listo': 'Listo para Retirar',
      'entregado': 'Entregado'
    };
    return estados[estado] || estado;
  };

  return (
    <div className="seguimiento-container" style={{ maxWidth: '800px', margin: '40px auto', padding: '20px' }}>
      <h1 style={{ color: '#2d5a27', marginBottom: '20px' }}>Controlá tu Pedido</h1>
      
      <form onSubmit={buscarPedidos} style={{ display: 'flex', gap: '10px', marginBottom: '30px' }}>
        <input 
          type="text" 
          value={dniBusqueda}
          onChange={(e) => setDniBusqueda(e.target.value)}
          placeholder="Ingresá tu DNI sin puntos"
          style={{ flex: 1, padding: '12px', borderRadius: '5px', border: '1px solid #ccc' }}
          required
        />
        <button type="submit" style={{ padding: '12px 24px', background: '#2d5a27', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
          {cargando ? 'Buscando...' : 'Buscar'}
        </button>
      </form>

      {busquedaRealizada && pedidos.length === 0 && (
        <p style={{ textAlign: 'center', color: '#666' }}>No se encontraron pedidos asociados a este DNI.</p>
      )}

      <div className="lista-pedidos" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {pedidos.map(pedido => {
          const totalCalculado = pedido.items.reduce((acc, item) => acc + Number(item.subtotal), 0);
          
          return (
            <div key={pedido.pedido_id} className="tarjeta-pedido" style={{ border: '1px solid #eee', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
                <strong>Pedido #{pedido.pedido_id}</strong>
                <span style={{ 
                  background: pedido.estado === 'listo' ? '#dff0d8' : '#fcf8e3', 
                  color: pedido.estado === 'listo' ? '#3c763d' : '#8a6d3b',
                  padding: '4px 10px', borderRadius: '15px', fontSize: '14px', fontWeight: 'bold' 
                }}>
                  {traducirEstado(pedido.estado)}
                </span>
              </div>
              
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 15px 0' }}>
                {pedido.items.map((item, index) => (
                  <li key={index} style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '15px', 
                    marginBottom: '15px', 
                    paddingBottom: '15px',
                    borderBottom: '1px dashed #eaeaea',
                    fontSize: '15px' 
                  }}>
                    {/* Imagen del producto */}
                    <img 
                      src={item.imagen_url} 
                      alt={item.nombre} 
                      style={{ 
                        width: '60px', 
                        height: '60px', 
                        objectFit: 'cover', 
                        borderRadius: '8px',
                        border: '1px solid #eee'
                      }}
                    />
                    
                    {/* Info Central */}
                    <div style={{ flex: 1 }}>
                      <span style={{ fontWeight: 'bold', color: '#333', display: 'block' }}>
                        {item.cantidad}x {item.nombre}
                      </span>
                      <span style={{ fontSize: '13px', color: '#777' }}>
                        {item.formato} - {item.maduracion === 0 ? 'Fresco' : `${item.maduracion} días`}
                      </span>
                    </div>

                    {/* Precio a la derecha */}
                    <span style={{ fontWeight: 'bold', color: '#555' }}>
                      {formatearPrecio(item.subtotal)}
                    </span>
                  </li>
                ))}
              </ul>
              
              <div style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '18px', color: '#2d5a27' }}>
                Total: {formatearPrecio(totalCalculado)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SeguimientoPedidos;